export default function HoverHaileyIco() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" rx="11" fill="#EBE1F9" />
      <path
        d="M13.2567 9.47754C13.8067 10.595 14.7037 11.5037 15.8132 12.0671L16.4753 12.4034C16.7164 12.5258 16.7164 12.8703 16.4753 12.9928L15.8132 13.329C14.7037 13.8925 13.8067 14.8011 13.2567 15.9186L12.9245 16.5936C12.8033 16.8397 12.4525 16.8397 12.3313 16.5936L11.9991 15.9186C11.4491 14.8011 10.552 13.8925 9.44256 13.329L8.78049 12.9928C8.53933 12.8703 8.53933 12.5258 8.78049 12.4034L9.44256 12.0671C10.552 11.5037 11.4491 10.595 11.9991 9.47754L12.3313 8.80251C12.4525 8.55641 12.8033 8.55641 12.9245 8.80251L13.2567 9.47754Z"
        fill="#7F56D9"
      />
      <path
        d="M8.19764 5.80793C8.54544 6.51459 9.11273 7.08921 9.81435 7.44553L10.233 7.65816C10.3855 7.73561 10.3855 7.95345 10.233 8.0309L9.81435 8.24353C9.11273 8.59985 8.54544 9.17447 8.19764 9.88113L7.98754 10.308C7.91095 10.4636 7.68906 10.4636 7.61246 10.308L7.40236 9.88113C7.05456 9.17447 6.48727 8.59985 5.78565 8.24353L5.36697 8.0309C5.21447 7.95345 5.21447 7.73561 5.36697 7.65816L5.78565 7.44553C6.48727 7.08921 7.05456 6.51459 7.40236 5.80793L7.61246 5.38105C7.68906 5.22542 7.91095 5.22542 7.98754 5.38105L8.19764 5.80793Z"
        fill="#7F56D9"
      />
    </svg>
  );
}
